var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"i-main"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticStyle:{"padding":"24rem 14rem","box-sizing":"border-box"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }